import React, { useMemo } from 'react';
import { Box } from '@mui/system';
import { Combobox } from '@bestdoctor/spectrum-uikit/Combobox';
import type { ComboboxOption } from '@bestdoctor/spectrum-uikit/Combobox';
import { Company, DataPeriod, FinanceFiltersProps } from 'interfaces/global/globalInterfaces';
import { mainFiltersContainerStyle, mainFiltersSectionStyle, mainFiltersWrapperStyle } from 'ui/patients/mainFilters';

export const FinanceFilters: React.FC<FinanceFiltersProps> = ({
  dataPeriods,
  allCompanies,
  selectedCompanyByFinance,
  handleSelectedCompanyByFinance,
  selectedPeriodByFinance,
  handleSelectedPeriodByFinance,
}) => {
  const companyOptions: ComboboxOption<Company>[] = useMemo(
    () =>
      (allCompanies || []).map((company) => ({
        label: company.title,
        value: company,
      })),
    [allCompanies]
  );

  const periodOptions: ComboboxOption<DataPeriod>[] = useMemo(
    () =>
      (selectedCompanyByFinance ? dataPeriods || [] : []).map((period) => ({
        label: period.title,
        value: period,
      })),
    [dataPeriods, selectedCompanyByFinance]
  );

  const selectedCompanyOption = useMemo(
    () => companyOptions.find((option) => option.value.uuid === selectedCompanyByFinance?.uuid) || null,
    [companyOptions, selectedCompanyByFinance]
  );

  const selectedPeriodOption = useMemo(
    () => periodOptions.find((option) => option.value.uuid === selectedPeriodByFinance?.uuid) || null,
    [periodOptions, selectedPeriodByFinance]
  );

  return (
    <Box component="section" sx={mainFiltersSectionStyle}>
      <Box sx={mainFiltersWrapperStyle}>
        <Box sx={mainFiltersContainerStyle}>
          <Combobox<Company>
            label="Компания"
            placeholder="Компания"
            options={companyOptions}
            value={selectedCompanyOption?.value}
            searchable
            clearable
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterCompanyFinance', JSON.stringify(value));
                sessionStorage.removeItem('mainFilterCompanyFinanceCleared');
                sessionStorage.setItem('mainFilterPeriodFinance', JSON.stringify(''));
                handleSelectedCompanyByFinance(value);
              } else {
                sessionStorage.setItem('mainFilterCompanyFinance', JSON.stringify(''));
                sessionStorage.setItem('mainFilterCompanyFinanceCleared', 'true');
                sessionStorage.setItem('mainFilterPeriodFinance', JSON.stringify(''));
                handleSelectedCompanyByFinance(null);
              }
            }}
            size="m"
          />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Combobox<DataPeriod>
            label="Период данных"
            placeholder="Период данных"
            options={periodOptions}
            value={selectedPeriodOption?.value}
            searchable
            clearable
            onChange={(value, option) => {
              if (value && option) {
                sessionStorage.setItem('mainFilterPeriodFinance', JSON.stringify(value));
                handleSelectedPeriodByFinance(value);
              } else {
                sessionStorage.setItem('mainFilterPeriodFinance', JSON.stringify(''));
                handleSelectedPeriodByFinance(null);
              }
            }}
            size="m"
          />
        </Box>
      </Box>
    </Box>
  );
};
